import { createFileRoute } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";
import { useApiKeys, useApiKeyMutations } from "#app/hooks/settings/use-api-key-mutations";
import { useAppData } from "#app/lib/data";
import { ApiKeyFormView } from "#app/components/settings/api-key-form-view";
import type { Permissions } from "#app/components/settings/permission-badge";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";

function AccessEditPage() {
  const { apiKeyId } = Route.useParams();
  const { replace } = useAppNavigate();
  const { currentUser } = useAppData();
  const { apiKeys, isLoading } = useApiKeys(currentUser?.userId);
  const { updateApiKey } = useApiKeyMutations();

  const apiKey = apiKeys.find((k: any) => k.apiKeyId === apiKeyId);

  if (isLoading && !apiKey) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  if (!apiKey) {
    replace("/settings/access");
    return null;
  }

  async function handleSubmit(data: { name: string; permissions: Permissions }) {
    await updateApiKey(apiKeyId, {
      name: data.name,
      permissions: data.permissions,
    });
    replace(`/settings/access/${apiKeyId}`);
  }

  return (
    <ApiKeyFormView
      apiKey={{
        apiKeyId: apiKey.apiKeyId,
        name: apiKey.name,
        permissions: apiKey.permissions,
      }}
      onCancel={() => replace(`/settings/access/${apiKeyId}`)}
      onSubmit={handleSubmit}
    />
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/access/$apiKeyId/edit",
)({ component: AccessEditPage });
